var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "67px",
    width: "67px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    sketch: "http://www.bohemiancoding.com/sketch/ns",
    xlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "miu",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1",
    transform: "translate(-755.000000, -659.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slice",
    transform: "translate(215.000000, 119.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767,682 C773.075133,682 778,677.075133 778,671 C778,664.924867 773.075133,660 767,660 C760.924867,660 756,664.924867 756,671 C756,677.075133 760.924867,682 767,682 Z M761.778872,667 L772.221128,667 L767,671.362053 L761.778872,667 Z M773,667.650854 L773,674.295797 L769.013034,670.973326 L773,667.650854 Z M772.284983,675 L761.715017,675 L765.761828,671.619044 L767,672.650854 L768.238172,671.619044 L772.284983,675 Z M761,674.295797 L761,667.650854 L764.986966,670.973326 L761,674.295797 Z",
    fill: "#0a7ea3",
    id: "circle-social-email-glyph"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.e6301e7f663cb104b2f55ec0e6da732a.svg";
export { ForwardRef as ReactComponent };